import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Redirect } from 'react-router-dom'

import { Form, Button, Col, Row, Spinner } from 'react-bootstrap';
import { TEST_X_API_KEY, X_API_KEY } from '../../utils/authentication';

import { signIn, signInReset } from '../../actions/index';
import { isAuthenticated } from '../../utils/authentication';

class LoginForm extends React.Component {

    constructor() {

        super();

        this.state = {
            apiKey: '',
            errorAccessKey: false,
            loginText: "Private Workspace",
        };

        this.handleApiKey = this.handleApiKey.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onTryDemo = this.onTryDemo.bind(this);
    }

    componentDidMount() {
        this.props.signInReset();
    }

    handleApiKey(e) {
        this.setState({ apiKey: e.target.value });
    }

    onSubmit(e) {

        e.preventDefault();
        e.stopPropagation();

        this.setState({
            errorAccessKey: false,
            loginText: (<div>
                <Spinner
                    style={{ marginRight: "0.25rem" }}
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                />
                Logging in
                        </div>),
        });

        localStorage.setItem(TEST_X_API_KEY, this.state.apiKey);

        if (!this.state.apiKey) {
            this.setState({ errorAccessKey: true, loginText: "Private Workspace" });
            localStorage.removeItem(TEST_X_API_KEY);
            this.props.signInReset();
        } else {

            localStorage.setItem(TEST_X_API_KEY, this.state.apiKey);

            this.props.signIn().then(() => {
                if (this.props.authResult === true) {

                    localStorage.setItem(X_API_KEY, this.state.apiKey);
                    localStorage.removeItem(TEST_X_API_KEY);
                    this.props.signInReset();
                    this.setState({ loginText: "Log In" });
                } else {
                    this.setState({ errorAccessKey: true, loginText: "Log In" });
                    localStorage.removeItem(TEST_X_API_KEY);
                    this.props.signInReset();
                }
            });
        }
    }

    onTryDemo(e) {
        localStorage.setItem(X_API_KEY, '');
        this.setState({ isSubmitted: true });
    }

    render() {

        if (isAuthenticated()) {
            return (<Redirect to='/' />);
        }

        return (
            <div style={{ maxWidth: '90vh' }}>
                <Row>
                    <Col> <h2>Tuner4TRONIC LED Modules</h2> </Col>
                </Row>
                <Row>
                    <Col>
                        <h6 className="OsramColor">
                            User log in
                        </h6>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {/* <br /> */}
                        <Form
                            validated={this.state.validated}
                            onSubmit={this.onSubmit} >
                            <Form.Group controlId="formApiKey">
                                <Form.Label>Access key</Form.Label>
                                <Form.Control type="password" placeholder="Access key" value={this.state.apiKey} onChange={this.handleApiKey} />
                                {
                                    this.state.errorAccessKey
                                        ? <Form.Control.Feedback type="danger" > Please insert a correct <i>Access Key</i> or try demo.</Form.Control.Feedback>
                                        : null
                                }
                            </Form.Group>
                            <br />
                            <Button className="btn-landing" variant="primary" type="submit">
                                {this.state.loginText}
                            </Button>
                            <Button className="btn-landing" variant="secondary" type="button" onClick={this.onTryDemo}>
                                Public Mode
                            </Button>
                        </Form>
                    </Col>
                </Row>
                <Row>

                    <Col>
                        <div>
                            <br />
                            <b>Public Mode:</b> This mode provides the full functionality of the configurator. LED Modules can be created, saved and can be downloaded. But all ledmodules can be seen, edited and deleted by anybody using the demo mode. No Access Key is required.
                            <br />
                            <br />
                            <b>Private Workspace:</b> This mode provides the full functionality of the configurator. LED Modules can be created and saved and can be downloaded. All ledmodules can be seen, edited and deleted only by the user of the Access Key. In order to request a free Access Key, please register via <a href="mailto:T4Tsupport@inventronicsglobal.com">T4Tsupport@inventronicsglobal.com</a>. One organization shall share one workspace.
                        </div>
                    </Col>
                </Row>
            </div>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        authResult: state.auth.result,
    };
};

const mapDispatchToProps = {
    signIn,
    signInReset,
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginForm));
